import api from "../api";

export const messagesApi = {
  async getIncidentMessages(
    incidentID: number,
    page: number = 1,
    limit: number = 100
  ) {
    const response = await api.get(`/incidents/${incidentID}/messages`, {
      params: {
        offset: (page - 1) * limit,
        limit,
      },
    });
    return response.data;
  },

  async sendMessage(incidentID: number, message: string) {
    const response = await api.post(`/incidents/${incidentID}/messages`, {
      message,
      messageTime: new Date().toISOString(),
    });
    return response.data;
  },

  async getGroupMessages(groupID: string, page: number = 1, limit: number = 100) {
    const response = await api.get(`/group/${groupID}/messages`, {
      params: {
        offset: (page - 1) * limit,
        limit,
      },
    });
    return response.data;
  },

  async sendGroupMessage(groupID: string, message: string) {
    const response = await api.post(`/group/${groupID}/messages`, {
      message,
      messageTime: new Date().toISOString(),
    });
    return response.data;
  },

  async joinMeet(incidentID: number) {
    const response = await api.post(`/incidents/${incidentID}/join-meet`);
    return response.data;
  },
};
